export const classes = {
  field:
    'flex items-center border-b-[1.5px] border-[rgba(70,60,50,0.18)] px-0.5 pb-1 pt-2 transition-colors duration-[160ms] ease-[ease] focus-within:border-b-brand-accent dark:border-[rgba(255,255,255,0.16)] dark:focus-within:border-b-brand-accent-dark',
  input:
    'w-full border-none bg-transparent text-[15px] text-taupe-3 outline-none placeholder:text-taupe-1 dark:text-mauve-1 dark:placeholder:text-mauve-3',
  clear:
    'flex size-[26px] flex-none items-center justify-center border-none bg-transparent text-taupe-1 transition-colors duration-[140ms] ease-[ease] hover:text-taupe-3 dark:text-mauve-3 dark:hover:text-mauve-1',
  clearHidden: 'invisible',
};
